import { Reveal, Overline } from "./anim";
import { MANIFESTO } from "@/data";

export default function Manifesto() {
  return (
    <section id="manifesto" className="relative bg-ink py-24 md:py-36 border-t border-line-d" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal className="mb-16 md:mb-24 max-w-2xl">
          <Overline>The Manifesto</Overline>
          <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl text-sand tracking-tight leading-tight">
            Four beliefs that shape every room we walk into.
          </h2>
        </Reveal>

        <div className="divide-y divide-line-d border-y border-line-d">
          {MANIFESTO.map((m, i) => (
            <Reveal key={m.n} delay={i * 0.05}>
              <div className="grid grid-cols-12 gap-6 py-10 md:py-14 group" data-testid={`manifesto-item-${i}`}>
                <div className="col-span-12 md:col-span-3">
                  <span className="font-mono text-terra text-sm">{m.n}</span>
                </div>
                <div className="col-span-12 md:col-span-9 grid md:grid-cols-2 gap-6">
                  <h3 className="font-display text-3xl md:text-4xl lg:text-5xl text-sand leading-[1.05] group-hover:text-terra transition-colors duration-500">
                    {m.title}
                  </h3>
                  <p className="text-muted-d text-base md:text-lg leading-relaxed self-end max-w-md">{m.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
